import { createContext, useContext } from 'react';
import {SessionContext} from "./SessionContext";
import HybridModelSessionContext from "./HybridModelSessionContext";

export const EnersoundSessionContext = createContext<{
    session: SessionContext | HybridModelSessionContext | null;
    setSession: (s: SessionContext | HybridModelSessionContext) => void;
}>({
    session: null,
    setSession: () => {},
});

export const useEnersoundSessionContext = () => useContext(EnersoundSessionContext);